import { Injectable } from "@angular/core";
import { Headers, RequestOptions } from "@angular/http";
import { AuthHttp } from "./auth.http";
import { ConfigStore } from '../stores/config.store';

@Injectable()
export class AuthService {    

    private authKey;

    constructor(private http: AuthHttp, private config: ConfigStore) {

        this.authKey = http.authKey;
    }

    // Convert a Json object to urlencoded format
    toUrlEncodedString(data: any) {
        var body = "";
        for (var key in data) {
            if (body.length) {
                body += "&";
            }
            body += key + "=";
            body += encodeURIComponent(data[key]);
        }

        return body;
    }

    login(agenzia: string, username: string, password: string, persist: boolean = false): any {

        let baseUrl = this.config.getValue('webServiceURL');
        let url = baseUrl + '/api/auth/login';

        console.log('[AuthService] login | url: '+ url);

        var data = {
            agenzia: agenzia,
            username: username,
            password: password,
            client_id: "zefiro.pocket.app",       // ToDo: spostare nel model locator!
            grant_type: "password",
            scope: "offline_access profile email" // space-separated list of scopes for wich the token is issued
        }

        return this.http.post(
            url,
            this.toUrlEncodedString(data),
            new RequestOptions({
                headers: new Headers({
                    "Content-Type": "application/x-www-form-urlencoded"
                })
            })).map(response => {

                let auth = response.json();
                this.setAuth(auth, persist);

                if (auth)
                    this.http.authData = auth;

                return auth;
            });
    }

    logout(): any {

        var baseUrl = this.config.getValue('webServiceURL');
        var url = baseUrl + '/api/auth/logout';

        return this.http.post(url, null)
            .map(response => {
                this.setAuth(null);
                return true;
            });
    }

    // Persist auth into localStorage or removes it if a NULL argument is given
    setAuth(auth: any, persist: boolean = false): boolean {
        if (auth) {
            if (persist)
                localStorage.setItem(this.authKey, JSON.stringify(auth));
            else
                sessionStorage.setItem(this.authKey, JSON.stringify(auth));
        }
        else {
            localStorage.removeItem(this.authKey);
            sessionStorage.removeItem(this.authKey);
        }
        return true;
    }

    // Retrieves the auth JSON object  (or NULL if none)
    getAuth(): any {
        var i = sessionStorage.getItem(this.authKey) || localStorage.getItem(this.authKey);
        if (i) {
            return JSON.parse(i);
        }

        return null;
    }

    // Returns TRUE if the user is logged in, FALSE otherwise
    isLoggedIn(): boolean {
        return localStorage.getItem(this.authKey) != null;
    }
}


// WEBPACK FOOTER //
// ./src/services/auth.service.ts